import React from "react";

import type { ProcessedQuaddieSelection } from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { SelectionClamp } from "../selections/SelectionClamp";
import { getSelectionClickHandler } from "@/features/entries/util/selection-helpers";

import * as styles from "./QuaddieOutcome.module.scss";

interface QuaddieOutcomeProps {
  entryId: number;
  selection: ProcessedQuaddieSelection;
  isPreview?: boolean;
  isEntryWon?: boolean;
}

const QuaddieOutcome = ({
  entryId,
  selection,
  isPreview = false,
  isEntryWon,
}: QuaddieOutcomeProps) => {
  const outcomes = Object.values(selection.outcomes || {});
  const isWon = outcomes.some((outcome) => outcome.outcomeResult === "WIN");

  return (
    <div
      className={cx(styles.outcome, {
        [styles.won]: isWon,
      })}
      onClick={getSelectionClickHandler(selection)}
    >
      <div className={styles.raceIcon}>
        R{selection.event.attributes?.raceNumber}
      </div>
      <div className={styles.runners}>
        {outcomes.map((outcome, index) => {
          const isLast = index === outcomes.length - 1;
          return (
            <span
              key={`quaddie-pick-${index}-${entryId}`}
              className={cx({
                [styles.won]: outcome.outcomeResult === "WIN",
              })}
            >
              <span
                className={cx({
                  [styles.isVoid]: outcome.outcomeResult === "VOID",
                })}
              >
                {outcome.attributes?.runnerNumber}
              </span>
              {!isLast ? `, ` : ` `}
            </span>
          );
        })}
      </div>
      <div className={styles.clamp}>
        <SelectionClamp
          selection={selection}
          isPreview={isPreview}
          isEntryWon={isEntryWon}
        />
      </div>
    </div>
  );
};

export { QuaddieOutcome };
